/**
 * This File contains all the logic for reCAPTCHA integration.
 * The functions in this file need to be used in different parts of the application, and in conjunction with the RecaptchaFormComponent.tsx file.
 *
 * Usage:
 * 1. Include <RecaptchaFormComponent /> in your form component to load the reCAPTCHA script.
 * 2. Call `executeRecaptcha()` to get a token when the form is submitted and pass it through to the api endpoint.
 * 3. Use `verifyRecaptchaToken(token)` on the server side api endpoint to verify the token.
 */

// For some reason this project didn't like grecaptcha when others didn't care.
// This is just a simple workaround
declare global {
  interface Window {
    grecaptcha: any; // or use a more specific type
  }
}

/**
 * Executes reCAPTCHA verification and returns a token
 *
 * @returns {Promise<string>} A promise that resolves to the reCAPTCHA token
 */
const executeRecaptcha = async () => {
  return new Promise<string>((resolve, reject) => {
    if (typeof window !== "undefined" && window.grecaptcha) {
      window.grecaptcha.enterprise.ready(() => {
        window.grecaptcha.enterprise
          .execute(process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY, {
            action: "submit",
          })
          .then((token: string) => {
            resolve(token);
          })
          .catch((error: Error) => {
            console.error('recaptcha error:', error);
            reject(error);
          });
      });
    } else {
      reject(new Error("reCAPTCHA not loaded"));
    }
  });
};




export { executeRecaptcha };
